<template>
	<div class="row align-items-center justify-content-center">
		<div class="col-md-8 col-lg-6 col-xl-5">
			<div class="card shadow-none">
				<div class="card-body p-4">
					<div class="text-center mt-2">
						<h5>{{$t('header-recovery-password')}}</h5>
					</div>
					<div class="p-2 mt-4">
						<form @submit.prevent="onRecoveryPasswordStep2">
							<div class="mb-3">
								<label class="form-label" for="username">{{$t('label-username')}}</label>
								<input
									type="text"
									class="form-control"
									id="username"
									v-model="username"
									autocomplete="username"
									required
								/>
							</div>
							<div class="mb-3">
								<label class="form-label" for="code">{{$t('label-recovery-password-code')}}</label>
								<input
									type="text"
									class="form-control"
									id="code"
									v-model="code"
									autocomplete="off"
									required
								/>
							</div>
							<div class="mt-3 text-end d-grid">
								<router-link :to="{path: '/recovery-password', query: {username}}" class="btn btn-secondary">{{$t('btn-resend-code')}}</router-link>
							</div>
							<hr/>
							<div class="mb-3">
								<label class="form-label" for="password1">{{$t('label-password')}}</label>
								<div class="input-group">
									<input
										:type="type"
										class="form-control"
										id="password1"
										v-model="password1"
										autocomplete="new-password"
										required
									/>
									<button
										@click="buttonEye(), (clickedEye = !clickedEye)"
										class="btn btn-outline-secondary shadow-none"
										type="button"
									>
										<font-awesome-icon
											class="eyeButton"
											:icon="clickedEye ? 'eye-slash' : 'eye'"
										>
										</font-awesome-icon>
									</button>
								</div>
							</div>
							<div class="mb-3">
								<label class="form-label" for="password2">{{$t('label-password-repeat')}}</label>
								<div class="input-group">
									<input
										:type="type"
										class="form-control"
										id="password2"
										v-model="password2"
										autocomplete="new-password"
										required
									/>
									<button
										@click="buttonEye(), (clickedEye = !clickedEye)"
										class="btn btn-outline-secondary shadow-none"
										type="button"
									>
										<font-awesome-icon
											class="eyeButton"
											:icon="clickedEye ? 'eye-slash' : 'eye'"
										>
										</font-awesome-icon>
									</button>
								</div>
							</div>
							<div class="mt-3 text-end d-grid">
								<button class="btn btn-lg btn-primary" type="submit" :disabled="btnRecoveryPasswordDisabled">{{$t('btn-change-password')}}</button>
							</div>
						</form>
						<div class="alert alert-warning text-center mt-3 mb-0" v-if="error">{{error}}</div>
					</div>
				</div>
			</div>
			<div class="card shadow-none">
				<div class="card-body p-4 text-center">
					{{$t('text-remember-password')}} <router-link :to="{path: '/login'}">{{$t('btn-login')}}</router-link>
				</div>
			</div>
			<div class="card shadow-none">
				<div class="card-body p-4 text-center">
					{{$t('text-dont-have-account')}} <router-link :to="{path: '/register'}">{{$t('text-register')}}</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Восстановление пароля | byLex Account'});
	},
	data: () => ({
		username: '',
		code: '',
		password1: '',
		password2: '',
		
		clickedEye: false,
		type: 'password',
		
		error: '',
		btnRecoveryPasswordDisabled: false,
	}),
	methods: {
		async onRecoveryPasswordStep2(){
			this.btnRecoveryPasswordDisabled = true;
			this.error = '';
			
			const res = await this.authModel.doRecoveryPasswordStep2({
				username: this.username,
				code: this.code,
				password1: this.password1,
				password2: this.password2,
			});
			
			// если пользователь найден
			if (res && res.success){
				document.location = this.$route.query.from != undefined ? this.$route.query.from : '/login';
			} else {
				// ошибка
				this.error = res.error;
			}
			
			this.btnRecoveryPasswordDisabled = false;
		},
		
		buttonEye() {
			if (this.type === 'password'){
				this.type = 'text';
			} else {
				this.type = 'password';
			}
		},
	},
	mounted(){
		this.username = this.$route.query.username || '';
		this.code = this.$route.query.code || '';
		
		window.scrollTo(0, 0);
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		next();
	},
	components: {},
};
</script>